import { Link } from "react-router-dom";
import Logo, { BrandFooter } from "@/components/Logo";

export default function PublicHeader() {
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200 px-4 sm:px-6 py-3">
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-3">
        <Logo size="md" />
        <nav className="flex items-center gap-4 sm:gap-6 text-sm font-medium text-slate-700">
          <Link to="/about" className="hidden sm:inline hover:text-teal-700">About</Link>
          <Link to="/faq" className="hidden sm:inline hover:text-teal-700">FAQ</Link>
          <Link to="/login" className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-4 py-1.5">Sign in</Link>
        </nav>
      </div>
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="mt-20 border-t border-slate-200 bg-white">
      <div className="max-w-6xl mx-auto px-6 py-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-8 text-sm">
        <div>
          <BrandFooter />
          <p className="mt-3 text-slate-500 text-xs leading-relaxed max-w-xs">
            Hyperlocal network — meet real neighbours in your pincode across India.
          </p>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-2">Explore</div>
          <ul className="space-y-1 text-slate-600">
            <li><Link to="/about" className="hover:text-teal-700">About</Link></li>
            <li><Link to="/faq" className="hover:text-teal-700">FAQ</Link></li>
            <li><Link to="/" className="hover:text-teal-700">Home</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-2">Legal</div>
          <ul className="space-y-1 text-slate-600">
            <li><Link to="/about" className="hover:text-teal-700">Privacy Policy</Link></li>
            <li><Link to="/about" className="hover:text-teal-700">Terms &amp; Conditions</Link></li>
            <li><a href="mailto:hello@mylivefriend.com" className="hover:text-teal-700">Contact Us</a></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-2">Cities</div>
          <ul className="space-y-1 text-slate-600">
            <li><Link to="/pincode/400001" className="hover:text-teal-700">Mumbai</Link></li>
            <li><Link to="/pincode/110001" className="hover:text-teal-700">Delhi</Link></li>
            <li><Link to="/pincode/560001" className="hover:text-teal-700">Bengaluru</Link></li>
            <li><Link to="/pincode/380001" className="hover:text-teal-700">Ahmedabad</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-4 text-center text-xs text-slate-400">© 2026 MyLiveFriend. All rights reserved.</div>
    </footer>
  );
}
